module.exports = __webpack_public_path__ + "img/branding-logo-white.1c800541.svg";